/**
 * Frontend mirror of backend CommissionCalculationStatus (cn/enums/CommissionCalculationStatus.java).
 *
 * Ordinal order MUST match the backend declaration exactly — the status column is persisted
 * @Enumerated(ORDINAL) (SMALLINT), so the ordinal NUMBER (not the name) is what the DB stores and
 * what QL filters must bind. Append-only: new values may only be added at the end, existing ordinals
 * must never be reordered or removed.
 *
 *   ACTIVE     → ordinal 0  — the live calculated row currently in effect.
 *   SUPERSEDED → ordinal 1  — replaced by a newer calculation (reserved audit mode).
 */
export enum CommissionCalculationStatusEnum {
    ACTIVE,
    SUPERSEDED,
}
